import type React from 'react'
import { GraviButton, Texto } from '@gravitate-js/excalibrr'
import { useNavigate } from 'react-router-dom'
import type { ICellRendererParams } from 'ag-grid-community'
import { getDaysAgo } from '../utils/getDaysAgo'
import { handleNavigation } from '../../../utils/navigationHelpers'

interface SupplierNameCellRendererProps extends ICellRendererParams {
  data: {
    supplierId: string
    supplierName: string
  }
  context?: {
    assignedToMe?: boolean
  }
}

export function SupplierNameCellRenderer({ data, context }: SupplierNameCellRendererProps) {
  const navigate = useNavigate()
  const assignedToMe = context?.assignedToMe || false

  function handleClick(event: React.MouseEvent) {
    if (data?.supplierId) {
      // Get the current period dates (same 30-day period as context)
      const currentPeriodStart = getDaysAgo(30)
      const currentPeriodEnd = new Date()
      const startDate = currentPeriodStart.toLocaleDateString('en-US')
      const endDate = currentPeriodEnd.toLocaleDateString('en-US')

      const assignedParam = assignedToMe ? '&assigned_to_me=true' : '&assigned_to_me=false'
      const url = `/supplier_rec/match_view?status=all&supplier_name=${encodeURIComponent(data.supplierName)}&date_range[]=${startDate}&date_range[]=${endDate}${assignedParam}`
      handleNavigation(url, navigate, event)
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start' }}>
      <GraviButton appearance='link' size='small' onClick={handleClick} style={{ textAlign: 'left', padding: 0 }}>
        <Texto
          category='p2'
          appearance='default'
          weight='600'
          style={{ fontSize: '14px', textDecoration: 'underline' }}
        >
          {data?.supplierName || 'N/A'}
        </Texto>
      </GraviButton>
    </div>
  )
}
